import { SavingsPriceSidePanelProps } from "common/blocks/Sidebar/SavingsPriceSidePanel";
import { DynamicSidebar } from "services/cms/models/dynamicSidebar";

export type SavingsSidePanelContentProps = {
    ourPrice: number;
    enquiryLink: string;
    estimatedMarketPrice: number;
    originalRetailPrice: number;
    savingsAgainstEstimatedMarketPrice: number;
    savingsAgainstOriginalRetailPrice: number;
    showEstimatedMarketPriceSaving: boolean;
    dynamicSavingsSidebar: DynamicSidebar;
};

const SavingsSidePanelContentResolver = (
    props: SavingsSidePanelContentProps
): SavingsPriceSidePanelProps => {
    const {
        ourPrice,
        enquiryLink,
        estimatedMarketPrice,
        originalRetailPrice,
        savingsAgainstEstimatedMarketPrice,
        savingsAgainstOriginalRetailPrice,
        showEstimatedMarketPriceSaving,
        dynamicSavingsSidebar,
    } = props;

    return {
        summary: showEstimatedMarketPriceSaving
            ? dynamicSavingsSidebar?.elements.secondLinkedSidebar.linkedItems[0].elements.content
                  .value
            : dynamicSavingsSidebar?.elements.firstLinkedSidebar.linkedItems[0].elements.content
                  .value,
        comparisonPrice: showEstimatedMarketPriceSaving
            ? estimatedMarketPrice
            : originalRetailPrice,
        salePrice: ourPrice,
        savings: showEstimatedMarketPriceSaving
            ? savingsAgainstEstimatedMarketPrice
            : savingsAgainstOriginalRetailPrice,
        savingsLabel: showEstimatedMarketPriceSaving
            ? dynamicSavingsSidebar?.elements.savingsLabel2.value
            : dynamicSavingsSidebar?.elements.savingsLabel1.value,
        salePriceLabel: showEstimatedMarketPriceSaving
            ? dynamicSavingsSidebar?.elements.salePriceLabel2.value
            : dynamicSavingsSidebar?.elements.salePriceLabel1.value,
        comparisonPriceLabel: showEstimatedMarketPriceSaving
            ? dynamicSavingsSidebar?.elements.comparisonPriceLabel2.value
            : dynamicSavingsSidebar?.elements.comparisonPriceLabel1.value,
        enquiryLink: enquiryLink,
    };
};

export default SavingsSidePanelContentResolver;
